var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.488,
    height: 36.488,
    viewBox: "0 0 36.488 36.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-server-176305",
    transform: "translate(-75.832 -5.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M103.47,14.995H76.608a.734.734,0,0,1-.776-.776V6.61a.734.734,0,0,1,.776-.776H103.47a.734.734,0,0,1,.776.776v7.608A.734.734,0,0,1,103.47,14.995ZM77.385,13.442h25.308V7.387H77.385Z",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M90.66,220.325H76.608a.734.734,0,0,1-.776-.776V211.94a.734.734,0,0,1,.776-.776H103.47a.734.734,0,0,1,.776.776v3.028a.776.776,0,0,1-1.553,0v-2.251H77.385v6.055H90.66a.734.734,0,0,1,.776.776.778.778,0,0,1-.776.776Z",
    transform: "translate(0 -191.667)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M90.815,425.665H76.608a.734.734,0,0,1-.776-.776V417.28a.734.734,0,0,1,.776-.776H90.737a.776.776,0,0,1,0,1.553H77.385v6.055h13.43a.734.734,0,0,1,.776.776.778.778,0,0,1-.776.776Z",
    transform: "translate(0 -383.343)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M144.5,64.549h-4.891a.776.776,0,0,1,0-1.553H144.5a.776.776,0,0,1,0,1.553Z",
    transform: "translate(-58.808 -53.358)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M144.5,269.887h-4.891a.776.776,0,1,1,0-1.553H144.5a.776.776,0,1,1,0,1.553Z",
    transform: "translate(-58.808 -245.033)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M144.5,475.217h-4.891a.776.776,0,1,1,0-1.553H144.5a.734.734,0,0,1,.776.776A.778.778,0,0,1,144.5,475.217Z",
    transform: "translate(-58.808 -436.699)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M393.318,58.333a1.245,1.245,0,1,1-1.242-1.165,1.205,1.205,0,0,1,1.242,1.165",
    transform: "translate(-294.041 -47.918)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M310.837,278.645H290.108a.734.734,0,0,1-.776-.776V259.78a.734.734,0,0,1,.776-.776h20.728a.734.734,0,0,1,.776.776v18.088A.734.734,0,0,1,310.837,278.645Zm-19.952-1.553h19.176V260.556H290.885Z",
    transform: "translate(-199.293 -236.323)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M360.108,314.041a.734.734,0,0,1-.776-.776V300.61a.776.776,0,0,1,1.553,0v12.654a.835.835,0,0,1-.776.776Z",
    transform: "translate(-264.635 -274.436)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M445.278,314.041a.734.734,0,0,1-.776-.776V300.61a.776.776,0,1,1,1.553,0v12.654a.778.778,0,0,1-.776.776Z",
    transform: "translate(-344.138 -274.436)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M531.608,314.041a.734.734,0,0,1-.776-.776V300.61a.776.776,0,0,1,1.553,0v12.654a.835.835,0,0,1-.776.776Z",
    transform: "translate(-424.723 -274.436)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M511.306,360.887h-3.028a.776.776,0,0,1,0-1.553h3.028a.734.734,0,0,1,.776.776A.778.778,0,0,1,511.306,360.887Z",
    transform: "translate(-402.945 -329.977)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M426.136,412.217h-3.028a.776.776,0,0,1,0-1.553h3.028a.734.734,0,0,1,.776.776A.835.835,0,0,1,426.136,412.217Z",
    transform: "translate(-323.443 -377.891)",
    fill: "#3d73ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M339.806,380.717h-3.028a.776.776,0,1,1,0-1.553h3.028a.734.734,0,0,1,.776.776A.778.778,0,0,1,339.806,380.717Z",
    transform: "translate(-242.858 -348.488)",
    fill: "#3d73ec"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy2);
export default __webpack_public_path__ + "static/media/why2.eebc41d6bd1b08812f6337fd8996a6ab.svg";
export { ForwardRef as ReactComponent };